/** @jsx jsx */
import { jsx, css } from '@emotion/core' // eslint-disable-line
import React, { Component, useState } from 'react' // eslint-disable-line
import CodeMirror from 'react-codemirror'
import Markdown from 'react-markdown'
import { Layout } from 'antd'

import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/monokai.css'

const styles = {
  'main-body': css`
    display: flex;
    flex-direction: row;
    text-align: left;
  `,
  'main-editor': css`
    width: 50%;
    height: 100%;

    .CodeMirror, .code-editor {
      height: 100%;
    }
  `,
  'main-viewer': css`
    width: 50%;
    padding: 10px;
    height: 100%;
    overflow-y: scroll;
  `,
}

export default function Editor() {
  const options = {
    mode: 'markdown',
    lineNumbers: true,
    theme: 'monokai',
  }

  const [content, onContentChange] = useState('Input Markdown')

  return (
    <div className="main-page">
      <Layout className="main-body" css={styles['main-body']}>
        <div className="main-editor" css={styles['main-editor']}>
          <CodeMirror
            value={content}
            options={options}
            className="code-editor"
            onChange={onContentChange}
          />
        </div>
        <div className="main-viewer" css={styles['main-viewer']}>
          <Markdown source={content} />
        </div>
      </Layout>
    </div>
  )
}
